// ssn-config.ts
import { BehaviorSubject } from 'rxjs';

class SSNConfig {
  private _allow666$ = new BehaviorSubject<boolean>(false);

  setAllow666(value: boolean) {
    this._allow666$.next(value);
  }

  get allow666$() {
    return this._allow666$.asObservable();
  }

  get allow666() {
    return this._allow666$.value;
  }
}

export const ssnConfig = new SSNConfig();
